import StandardQuestionAnswer from 'models/common/form/questionAnswer/StandardQuestionAnswer';

export default class StandardQuestionAnswerService {
	toModel(answer) {
		return new StandardQuestionAnswer(answer);
	}
}
